import Icons from './../../assets/icons/icons.svg'

const SvgIconComponent = ({ name, color, size }) => (
  <svg className={`icon icon-${name}`} fill={color} width={size} height={size}>
    <use xlinkHref={`${Icons}#icon-${name}`} />
  </svg>
)

export default SvgIconComponent
